import React, { useEffect, useState } from "react";
import { FolderCheck } from "lucide-react";
import { api, AYLAR, formatNum as fmtTL } from "@/lib/api";

export function DosyaDurumuOzet({ reloadKey, onSelect }) {
  const now = new Date();
  const [yil, setYil] = useState(now.getFullYear());
  const [ay, setAy] = useState(now.getMonth() + 1);
  const [data, setData] = useState(null);
  const [all, setAll] = useState(false);
  useEffect(() => {
    api.get("/tahsilat/dosya-durumu-ozet", { params: { yil, ay } }).then((r) => setData(r.data)).catch((e) => setData(e?.response?.status === 403 ? { hidden: true } : { rows: [] }));
  }, [yil, ay, reloadKey]);
  const pick = (muvekkil, durum) => {
    const mm = String(ay).padStart(2, "0");
    const last = new Date(yil, ay, 0).getDate();
    const ayAd = AYLAR.find((a) => a.v === ay)?.n || ay;
    onSelect?.({ muvekkil, durum, from: `${yil}-${mm}-01`, to: `${yil}-${mm}-${last}`,
      label: `${ayAd} ${yil} · ${durum === "İNFAZ" ? "İnfaz" : durum ? "Kısmi Ödeme" : "tüm tahsilatlar"}` });
  };
  const cellBtn = "hover:underline cursor-pointer";
  if (data?.hidden) return null;
  const shown = all ? data?.rows || [] : (data?.rows || []).slice(0, 2);
  const more = (data?.rows?.length || 0) - 2;

  return (
    <div className="bg-white border border-slate-200 rounded-lg p-3" data-testid="dosya-durumu-ozet">
      <div className="flex items-center gap-2 flex-wrap mb-2 text-xs">
        <FolderCheck size={13} className="text-teal-600" />
        <span className="font-bold text-slate-700">Dosya Durumu Özeti</span>
        <span className="text-slate-500">(tahsilat tarihine göre)</span>
        {data && (
          <>
            <span className="px-2 py-0.5 rounded border text-emerald-700 bg-emerald-50 border-emerald-200 font-semibold" data-testid="dd-ozet-infaz-total">
              İnfaz: {fmtTL(data.infaz_total || 0)} ₺ · {data.infaz_count || 0}
            </span>
            <span className="px-2 py-0.5 rounded border text-amber-700 bg-amber-50 border-amber-200 font-semibold" data-testid="dd-ozet-kismi-total">
              Kısmi Ödeme: {fmtTL(data.kismi_total || 0)} ₺ · {data.kismi_count || 0}
            </span>
          </>
        )}
        <select value={ay} onChange={(e) => setAy(Number(e.target.value))} data-testid="dd-ozet-month" className="ml-auto px-2 py-0.5 border border-slate-300 rounded text-xs bg-white">
          {AYLAR.map((a) => <option key={a.v} value={a.v}>{a.n}</option>)}
        </select>
        <select value={yil} onChange={(e) => setYil(Number(e.target.value))} data-testid="dd-ozet-year" className="px-2 py-0.5 border border-slate-300 rounded text-xs bg-white">
          {[now.getFullYear() - 1, now.getFullYear()].map((y) => <option key={y} value={y}>{y}</option>)}
        </select>
      </div>
      {data && !data.rows.length && <div className="text-xs italic text-slate-400">Bu ay İnfaz / Kısmi Ödeme işaretli tahsilat yok.</div>}
      {data?.rows.length > 0 && (
        <table className="w-full text-xs">
          <thead className="text-[10px] uppercase text-slate-500">
            <tr><th className="text-left py-1">Müvekkil</th><th className="text-right py-1 text-emerald-700">İnfaz</th><th className="text-right py-1 text-amber-700">Kısmi Ödeme</th></tr>
          </thead>
          <tbody>
            {shown.map((g, i) => (
              <tr key={g.muvekkil} className="border-t border-slate-100 hover:bg-slate-50" data-testid={`dd-ozet-row-${i}`}>
                <td className="py-1 font-semibold text-slate-800">
                  <button type="button" onClick={() => pick(g.muvekkil, "")} className={cellBtn} data-testid={`dd-ozet-pick-all-${i}`} title="Bu müvekkilin ay içindeki tahsilatlarını listele">{g.muvekkil}</button>
                </td>
                <td className="py-1 text-right font-mono-tab text-emerald-700">
                  {g.infaz_count ? <button type="button" onClick={() => pick(g.muvekkil, "İNFAZ")} className={cellBtn} data-testid={`dd-ozet-pick-infaz-${i}`}>{fmtTL(g.infaz_total)} ₺ · {g.infaz_count}</button> : "—"}
                </td>
                <td className="py-1 text-right font-mono-tab text-amber-700">
                  {g.kismi_count ? <button type="button" onClick={() => pick(g.muvekkil, "KISMİ ÖDEME")} className={cellBtn} data-testid={`dd-ozet-pick-kismi-${i}`}>{fmtTL(g.kismi_total)} ₺ · {g.kismi_count}</button> : "—"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {more > 0 && (
        <button type="button" onClick={() => setAll((v) => !v)} data-testid="dd-ozet-more"
          className="mt-1 text-[11px] font-semibold text-teal-700 hover:text-teal-900 hover:underline">
          {all ? "Daha az göster" : `+${more} müvekkil daha`}
        </button>
      )}
    </div>
  );
}
